import { useNavigate } from "react-router-dom";
import "./style.css"

const MoreInfoItem = (props) => {
    const moreInfoData = props.moreInfoData;
    const navigate = useNavigate();

    return <div className='gallery-top-element'>
        <a className="wrapping_a" onClick={() => navigate(moreInfoData['link'])}>
            <h1 className='font-h'>{moreInfoData['title']}</h1>
            <img src={moreInfoData['img']} className="gallery-top-img" alt='extLink' />
            <h2 className='font-desc middle-text'>{moreInfoData['description']}</h2>
            <div className='gallery-panel-external'>
                <p className='gallery-description-text font-desc'>
                    {'Подробнее'}
                </p>
            </div>
        </a>
    </div >

}

export default MoreInfoItem;